import { Alert } from '@mui/material';
import { InfoIcon } from '../../../../../design-system';

export const FuelOfferFulfillmentsApproximationNote = () => (
  <Alert
    icon={<InfoIcon fontSize='inherit' />}
    sx={{
      alignItems: 'center',
      bgcolor: (theme) => theme.palette.Offers.translucent,
      color: 'text.primary',
      '& .MuiAlert-icon': {
        color: 'primary.main',
      },
    }}
  >
    Note: Offer fulfillments are approximations for fuel related offers.
  </Alert>
);
